import { Component, Input, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Observable } from 'rxjs';
import { TestExecutionService } from '../../services/test-execution-service';
import { TestExecutionControllerComponent } from 'src/app/user/test-execution-controller/test-execution-controller.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
    selector: 'app-action',
    template: `
  <mat-select [(ngModel)]="selectedValue" (ngModelChange)="onValueChanged()" (click)="onClick()">
  <mat-option value="Select Version">Select Version</mat-option>
    <mat-option *ngFor="let option of dropdownOptions" [value]="option">{{ option}}</mat-option>

  </mat-select>
`,
    standalone: false
})
export class DropdownComponent implements ICellRendererAngularComp {
  private params: any;
  public static scriptId : any;
  public selectedValue: any = 'Select Version'; // Default to 'Select Version'
  dropdownOptions;
 


  constructor( private testExecutionService:TestExecutionService,private x : TestExecutionControllerComponent,
    private spinner: NgxUiLoaderService) { }

  agInit(params: any): void {
    this.params = params;
    console.log(params.data)
    DropdownComponent.scriptId = params.data.manageTestScriptsMstrId;
   this.testExecutionService.retrieveScriptsVersion( params.data.manageTestScriptsMstrId).subscribe(response=>{
    console.log(DropdownComponent.scriptId)
    console.log(response)
    this.dropdownOptions = response;
   })
  }


  refresh(params: any): boolean {
    console.log(params)
    return true;
  }

  onValueChange(event) {
    console.log(event)
    this.params.setValue(this.selectedValue);
     console.log(this.x.testExecutionData);
     for(let i = 0;i<this.x.testExecutionData.length;i++){
    //   if(this.x.testExecutionData[i])
      }

  }

  onValueChanged() {
    // Call the callback function with the selected value
    this.params.onValueChange(this.selectedValue);
  }
  /**
   * @Author-Asha Waghadure
   * @Date-24-07-2025
   * @Note-when clickon select version retrive latest script version
   * @modiiedby-Asha W
   * @ModifiedDate-20-11-2025
   * @Note-calling api to get latest document version from vault
    */
   onClick() {
  this.spinner.start();

  this.testExecutionService
    .retrieveDocumentVersion(
      localStorage.getItem("dnsName"),
      localStorage.getItem("vaultDnsname"),
      this.params.data.manageTestScriptsMstrId,
      this.params.data.scriptName
    )
    .subscribe((response1) => {
      console.log("Document version updated:", response1);

      // Call retrieveScriptsVersion only after the first finishes
      this.testExecutionService
        .retrieveScriptsVersion(this.params.data.manageTestScriptsMstrId)
        .subscribe((response2) => {
          console.log("Updated Script Version:", response2);
          this.dropdownOptions = response2;
          this.spinner.stop();
        });
    });

  this.selectedValue = 'Select Version';
}

  


}
